import type { HTMLAttributes } from "vue"
import { defineComponent, renderSlot, type NoProps, type ReactiveComponent } from "vue-utils"

const FormButtons: ReactiveComponent<NoProps, HTMLAttributes> = (_, { slots, attrs }) => {
	return () => {
		const slot = renderSlot(slots)
		return (
			<div class="flex items-center justify-end">
				<div
					class="inline-grid spacing-4"
					style={{ gridTemplateColumns: `repeat(${Number(slot.children?.length ?? 0)}, 1fr)` }}
					{...attrs}
				>
					{slot}
				</div>
			</div>
		)
	}
}

export default defineComponent(FormButtons)
